class SetCssCustomProperties {
  constructor() {
    this.DOM = {
      bg: document.querySelector('.site-body__bg'),
    };
    // this.timer = null;
    this.#addEvent();
  }
  #addEvent() {
    document.addEventListener('scroll', this.#setProperties.bind(this), {passive: true});
  }
  #setProperties() {
    const offsetTop = window.pageYOffset;
    this.DOM.bg.style.top = `${offsetTop * -0.2}px`;
  }
}
export default SetCssCustomProperties;